import React, { useState } from "react";
import { Card, Form, Button } from "react-bootstrap";
import { API_DEFAULT_LANGUAGE } from "../../constants/apiConstants";
// ES6 module syntax
import LocalizedStrings from "react-localization";

let strings = new LocalizedStrings({
  en: {
    title: "Hourly Rated Calculator",
    hourlyRate: "Hourly Rate (€)",
    vatRate: "VAT Rate (%)",
    projectHours: "Project Hours",
    calculate: "Calculate",
    results: "Results:",
    baseAmount: "Total Hourly Fee (excl. VAT):",
    vatAmount: "VAT Amount:",
    totalWithVat: "Total Fee (incl. VAT):",
  },
  fi: {
    title: "Tuntipohjainen Hintalaskuri",
    hourlyRate: "Tuntihinta (€)",
    vatRate: "ALV-kanta (%)",
    projectHours: "Tunteja projektissa",
    calculate: "Laske",
    results: "Tulokset:",
    baseAmount: "Tuntihinta yhteensä (ilman ALV):",
    vatAmount: "ALV-osuus:",
    totalWithVat: "Hinta yhteensä (sis. ALV):",
  },
  sv: {
    title: "Timbaserad Priskalkylator",
    hourlyRate: "Timpris (€)",
    vatRate: "Moms (%)",
    projectHours: "Projekttimmar",
    calculate: "Beräkna",
    results: "Resultat:",
    baseAmount: "Total timpris (exkl. moms):",
    vatAmount: "Momsbelopp:",
    totalWithVat: "Total avgift (inkl. moms):",
  },
  ar: {
    title: "حاسبة السعر بالساعة",
    hourlyRate: "السعر بالساعة (يورو)",
    vatRate: "نسبة ضريبة القيمة المضافة (%)",
    projectHours: "ساعات المشروع",
    calculate: "حساب",
    results: "النتائج:",
    baseAmount: "إجمالي رسوم الساعة (غير شامل الضريبة):",
    vatAmount: "قيمة ضريبة القيمة المضافة:",
    totalWithVat: "إجمالي الرسوم (شامل الضريبة):",
  },
});

const LegalFeeCalculator = () => {
  const [hourlyRate, setHourlyRate] = useState(95);
  const [vatRate, setVatRate] = useState(25.5); // Default VAT in Finland is 25.5%
  const [projectHours, setProjectHours] = useState(100);

  const calculate = () => {
    const baseAmount = projectHours * hourlyRate;
    const vatAmount = (baseAmount * vatRate) / 100;
    const totalWithVat = baseAmount + vatAmount;

    return {
      baseAmount: baseAmount.toFixed(2),
      vatAmount: vatAmount.toFixed(2),
      totalWithVat: totalWithVat.toFixed(2),
    };
  };

  const result = calculate();

  const [lang, setLang] = useState(API_DEFAULT_LANGUAGE);

  const htmlLang = document.documentElement.lang || API_DEFAULT_LANGUAGE;
  strings.setLanguage(htmlLang);

  return (
    <div className="p-4 max-w-xl mx-auto">
      <Card className="shadow-sm">
        <Card.Body>
          <h2 className="text-center mb-4 calculator-title">{strings.title}</h2>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>{strings.hourlyRate}</Form.Label>
              <Form.Control
                type="number"
                value={hourlyRate}
                onChange={(e) => setHourlyRate(parseFloat(e.target.value) || 0)}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>{strings.vatRate}</Form.Label>
              <Form.Control
                type="text"
                value={vatRate}
                onChange={(e) => setVatRate(parseFloat(e.target.value) || 0)}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>{strings.projectHours}</Form.Label>
              <Form.Control
                type="number"
                value={projectHours}
                onChange={(e) => setProjectHours(parseFloat(e.target.value) || 0)}
              />
            </Form.Group>

            <Button variant="primary" className="w-100" disabled>
              {strings.calculate}
            </Button>
          </Form>

          <div className="mt-4 calculator-container">
            <h2 className="text-center calculator-title">{strings.results}</h2>
            <p>{strings.baseAmount} €{result.baseAmount}</p>
            <p>{strings.vatAmount} €{result.vatAmount}</p>
            <p>{strings.totalWithVat} €{result.totalWithVat}</p>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default LegalFeeCalculator;